/* eslint-disable*/
import React, { useRef, useState, useEffect } from 'react';
import { Button } from '@mui/material';

const ResponsiveButton = ({ label, minLabel, width, onClick }) => {
  const parentRef = useRef(null);
  const [buttonLabel, setButtonLabel] = useState(label);

  useEffect(() => {
    const minWidth = parseInt(width, 10);

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const eWidth = entry.contentRect.width;

        // 親が狭くなったら短く、ボタンマージンも小さく
        if (eWidth < minWidth) {
          setButtonLabel(minLabel);
        } else {
          setButtonLabel(label);
        }
      }
    });

    if (parentRef.current) {
      observer.observe(parentRef.current);
    }

    return () => {
      if (parentRef.current) {
        observer.unobserve(parentRef.current);
      }
    };
  }, [width, label, minLabel]);

  return (
    <div
      ref={parentRef}
      style={{ width: '100%', textAlign: 'center', paddingInline: '8px' }}
    >
      <Button
        variant="contained"
        color="detailButton"
        size="small"
        sx={{
          fontWeight: 'bold',
          borderRadius: 1,
          px: 1,
          py: 0.5,
          whiteSpace: 'nowrap',
          minWidth: 0,
          width: '100%',
          maxWidth: '100%'
        }}
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default ResponsiveButton;
